export enum DataFieldsEnum {
  NameMemberNr = 'name_membernr',
  Birthday = 'birthday',
  FirstName = 'firstname',
  LastName = 'lastname',
  Address = 'address',
  ShortAdress = 'shortaddress',
  Phone = 'phone',
  PhoneOther = 'phoneother',
  UserName = 'username',
  UserPwd = 'userpwd',
}

// Datafält som fungerar i fakturans innehåll. Taggarna byts ut av textgeneratorerna när
// fakturan skapas, och de är andra än de i DataFieldsEnum ovan, som mejlmotorn hanterar.
// Egen enum för att de inte ska dyka upp i editorer där de bara skulle bli stående text.
export enum InvoiceDataFieldsEnum {
  Name = 'namn',
  MemberNr = 'medlemsnr',
  LocalAss = 'localAss',
}
